module.exports = "./img/12cf12df71cc5a6b63c243bbb8055dc0.jpg";